export default {
	"monitoringStrategy": {
		"headerTips": "拖拽可调节优先级",
		"addTitle": "添加温度监控策略",
		"importantMonitor": "是否重点监控",
		"needTrackable": "温度必须可跟踪",
		"needWarning": "是否监控",
		"needPickupGoodsTemperature": "必须有提货货温",
		"needDeliveryGoodsTemperature": "必须有收货货温",
		"needPickupVehicleTemperature": "必须有提货车温",
		"trackingRequirements": "跟踪要求",
		"monitoringObject": "监控对象",
		"priority": "优先级",
		"originStationType": "始发站类型",
		"destStationType": "目的站类型",
		"log": "操作记录",
		"onlyEnableStrategyTypeSelectTips": "只能选择启用状态的监控策略"
	}
}


// WEBPACK FOOTER //
// ./src/lang/zh-CN/pages/monitoringStrategy/monitoringStrategy.js